import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

export default function PracticeEmbed() {
  const iframeUrl = "https://events-appsumo.app.toughtongueai.com/embed/6a7e2dacd83479d8b845b5f4?hidePoweredBy=true&bg=green-900&showTimer=true&spotlight=true&maxDuration=1200&promptUserInfo=true";
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="max-w-5xl mx-auto mt-24 px-4 sm:px-0"
    >
      <div className="bg-white rounded-[3rem] shadow-[0_30px_100px_rgba(0,0,0,0.1)] border border-blue-50 overflow-hidden">
        <div className="p-6 bg-slate-900 text-white flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-3 h-3 rounded-full bg-red-500 animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.8)]"></div>
            <div>
              <span className="text-lg font-black uppercase tracking-wider">Live Practice Lab</span>
              <p className="text-xs text-slate-400 font-bold">SESSION ACTIVE</p>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <span className="text-sm font-bold text-slate-300 flex items-center gap-2">
              <SafeIcon name="Mic" className="w-4 h-4 text-blue-400" /> Audio Ready
            </span>
            <span className="text-sm font-bold text-slate-300 flex items-center gap-2">
              <SafeIcon name="Video" className="w-4 h-4 text-teal-400" /> Video Ready
            </span>
          </div>
        </div>
        
        <div className="w-full bg-slate-100 relative" style={{ height: '709px' }}>
          <iframe 
            src={iframeUrl}
            width="100%" 
            height="100%" 
            frameBorder="0" 
            allow="microphone; camera; display-capture" 
            title="Practice Interface" 
            className="w-full h-full"
          ></iframe>
        </div>
      </div>
    </motion.div>
  );
}